
// - Basic settings - //

  // server
  export const API_URL = 'https://api.soud-usti.qtcloud.cz';
  // 'https://api.qtcloud.cz'; - Tetronik testovaci server
  // 'https://api.qa.qtcloud.cz'; - TETRAC  TESTOVACI
  // 'http://31.31.72.155:8888'; - SoFair testovaci

  export const APP_TITLE = 'Rezervační systém';

  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyCFn5kJ0M9ANeXrgVLgOiQLgCdetZgJGXo';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // single office mode
  export const SINGLE_OFFICE_MODE = true;

  // graph statistics
  // - default: month or year 
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1
  //  - main color in header and selected button
  export const COLOR_1 = 'rgb(0,150,136)';
  export const COLOR_1_BORDER_BOTTOM = 'rgba(3, 128, 116, 0.85)';
  export const COLOR_1_BORDER_LEFT = 'rgba(10, 153, 140, 0.85)';

  // color 2
  // - color in header under logo
  export const COLOR_2 = '#0f6f66';
  export const COLOR_2_BORDER_BOTTOM = 'rgba(21, 95, 88, 0.77)';
  export const COLOR_2_BORDER_RIGHT = 'rgba(18, 132, 122, 0.82)';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#2e3647';
  export const COLOR_3_BORDER_RIGHT = 'rgba(73, 79, 94, 0.71)';

// -------------------- //



// WEBPACK FOOTER //
// ./src/config.js